// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"DetailsTitle_modalTitle__3_ULA","titleEventBadge":"DetailsTitle_titleEventBadge__3GASN","titleText":"DetailsTitle_titleText__2yGXf"};